var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { parsePhoneNumberFromString, format } from 'libphonenumber-js';
import { formatRecordingFileName } from '../shared/utils/file-utils';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var DetailsService = /** @class */ (function () {
    function DetailsService(http) {
        this.http = http;
        this.onSetEventId = new BehaviorSubject(opener);
    }
    DetailsService.prototype.getEventDetails = function (eventId) {
        return this.http.get("/contacts/events/" + eventId);
    };
    DetailsService.prototype.setEventId = function (id) {
        this.onSetEventId.next(id);
    };
    DetailsService.prototype.getCallDetails = function (eventId) {
        return this.http.get("/calls/" + eventId);
    };
    DetailsService.prototype.createVoicemailFilename = function (event) {
        var currentEvent = __assign({}, event, { name: event.name || event.agentName, surname: event.surname || event.agentSurname, createdAt: event.createdAt || event.startDate });
        return ((currentEvent.name ? currentEvent.name : currentEvent.id) + "\n    _" + (currentEvent.surname ? currentEvent.surname : '') + formatRecordingFileName(currentEvent));
    };
    DetailsService.prototype.getRecordingUrl = function (eventId) {
        return "/calls/" + eventId + "/recording";
    };
    DetailsService.prototype.getFormatedNumber = function (number) {
        if (number.startsWith('webcall')) {
            return number;
        }
        var generalNumber = parsePhoneNumberFromString(number.toString());
        return format(generalNumber.number, generalNumber.country, 'INTERNATIONAL');
    };
    DetailsService.ngInjectableDef = i0.defineInjectable({ factory: function DetailsService_Factory() { return new DetailsService(i0.inject(i1.HttpClient)); }, token: DetailsService, providedIn: "root" });
    return DetailsService;
}());
export { DetailsService };
